export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!

export const WIN_MESSAGES = ['Bravo!', 'Felicitari', 'Ai reusit!', 'Super']
export const GAME_COPIED_MESSAGE = 'Jocul a fost copiat pe clipboard'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Nu sunt suficiente litere'
export const WORD_NOT_FOUND_MESSAGE = 'Cuvantul nu a fost gasit în lista'
export const HARD_MODE_ALERT_MESSAGE =
  'Modul Dificil poate fi activat doar la început!'
export const HARD_MODE_DESCRIPTION =
  'Orice indiciu dezvăluit trebuie folosit in ipoteze ulterioare'
export const HIGH_CONTRAST_MODE_DESCRIPTION = 'Pentru o viziune imbunatatita a culorilor'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Cuvantul era ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Trebuie utilizat ${guess} in positia ${position}`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `Solutia trebuie sa contina ${letter}`
export const ENTER_TEXT = 'ENTER'
export const DELETE_TEXT = 'DEL'
export const STATISTICS_TITLE = 'Statistici'
export const GUESS_DISTRIBUTION_TEXT = 'Ghiciti Distributia'
export const NEW_WORD_TEXT = 'Cuvant nou in'
export const SHARE_TEXT = 'Partajeaza'
export const SHARE_FAILURE_TEXT =
  'Nu se pot partaja rezultatele. Aceasta caracteristica este disponibila numai in contexte securizate (HTTPS), in unele sau în toate browserele compatibile.'
export const MIGRATE_BUTTON_TEXT = 'Transfer'
export const MIGRATE_DESCRIPTION_TEXT =
  'Faceti clic aici pentru a va transfera statisticile pe un dispozitiv nou.'
export const TOTAL_TRIES_TEXT = 'Numar total de incercari'
export const SUCCESS_RATE_TEXT = 'Rata de succes'
export const CURRENT_STREAK_TEXT = 'Serie de victorii curente'
export const BEST_STREAK_TEXT = 'Serie de victorii'
export const DISCOURAGE_INAPP_BROWSER_TEXT =
  "Utilizati un browser incorporat si este posibil să intampinati probleme la partajarea sau salvarea rezultatelor. Va recomandam să utilizati browserul implicit al dispozitivului."

export const DATEPICKER_TITLE = 'Alegeti un cuvânt din trecut'
export const DATEPICKER_CHOOSE_TEXT = 'Joaca'
export const DATEPICKER_TODAY_TEXT = "cuvantul de azi"
export const ARCHIVE_GAMEDATE_TEXT = 'Data Jocului'
